import {Box, styled} from '@mui/material';

export const EditorMainContainer = styled(Box)(() => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflowY: 'hidden',
}));

export const EditorHeaderSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px 24px 4px 24px',
}));

export const EditorContentSection = styled(Box)(() => ({
  flex: 1,
  height: '100%',
  overflowY: 'hidden',
}));
